import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { appendScript } from '../../../../utils/appendScript';
import ConvertTextToSpeech from '../../customeHooks/convertTextToSpeech';

const mapStateToProps = (state) => {
    const {
        answerCount,
        rightFeedbackProps,
        leftFeedbackProps,
    } = state.rootReducer.testPageDetails;

    return {
        answerCount,
        rightFeedbackProps,
        leftFeedbackProps,
    }
}

const SpeechDetailedFeedback = ({
    rightFeedbackProps: {
        correctAnswer,
        fileUrl,
        defaultFeedback: {
            combined_feedback,
            phrase_feedback,
            pace_feedback,
            accuracy,
        },
        score,      
    },
    leftFeedbackProps: {
        questionId,
    },
}) => {
    useEffect(() => {
        appendScript('detailedFeedback');
        appendScript('tab-animation');
        ConvertTextToSpeech({ correctAnswer, elementClass: 'correct-answer-', questionId, score });
         let el = document.getElementById('saFeedbackList').querySelector('li')
        if (!!el) {
            el.classList.add('active')
            let elChild = el.getAttribute('data-target')
            document.getElementById(elChild).classList.add('current')
        }

    }, [correctAnswer,
        questionId,
        score
    ]);


    return (
        <span>
                  <ul className="panelNav" data-panelwrapper="panelWrapper5" id="saFeedbackList">
                    {!!accuracy  && <li  data-target="accuracy-div"><a href="#accuracy-div">Accuracy</a></li>}
                    {!!pace_feedback  && <li data-target="pace-div"><a href="#pace-div">Pace</a></li>}
                    {!! phrase_feedback  && <li data-target="phrasing-div"><a href="#phrasing-div" >Phrasing</a></li>}
                  </ul>
                  <div className="panelWrapper" id="panelWrapper5" data-enter="slideright" data-exit="slideright">
                     {!!accuracy && <div className="panel current" id="accuracy-div">
                        <div className="pad-all width-80 mar-auto">
                           <p className="mar-top" dangerouslySetInnerHTML={{__html: accuracy}} />                             
                        </div>
                     </div> }

                     {!!pace_feedback && <div className="panel" id="pace-div">
                        <div className="pad-all width-80 mar-auto">
                           <p className="quote mar-top" dangerouslySetInnerHTML={{__html: pace_feedback}}/>
                        </div>
                     </div> }

                     {!! phrase_feedback && <div className="panel" id="phrasing-div">
                        <div className="pad-all width-80 mar-auto">
                             <p className="mar-top" dangerouslySetInnerHTML={{__html: phrase_feedback}} />  
                        </div>
                     </div> }
                  </div>

                 {!!combined_feedback && <div class="tutor-feedback">
                      <i class="fa fa-comments-o" aria-hidden="true"></i> 
                      <p><span>Feedback</span>{combined_feedback}</p>
                   </div>}



        </span>
    )
}

export default connect(mapStateToProps)(SpeechDetailedFeedback);